import React from "react";
import { Header } from "../../internal/Header/Header";

const Index = ({ children, hideSidebar, selectedItem }) => {
  return (
    <React.Fragment>
      <Header
        showSidebar={!hideSidebar}
        selectedItem={selectedItem}
        //   selectedSubItem="mediation"
      >
        {children}
      </Header>
    </React.Fragment>
  );
};

export default Index;
